<template>
	<div id="questionnaire" class="animated fadeIn">
		<div class="col-12 lg-col-6 md-col-10 p2 py4 ml-auto mr-auto">
			<div class="flex items-center mb4">
				<img src="/static/img/hvdk-green.png" class="mr2" width="13%">
				<h1 class="bold green">Byg med omtanke</h1>
			</div>
			<div class="clearfix" v-if="questionLoading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
          	<div v-else>
				<div v-if="isCustomer">
					<div class="flex">
						<div class="col-9 p0 pr2">
							<!-- Economy -->
							<div id="question1" class="mb4 question" v-if="!noEconomy">
								<div class="pb4 px3">
									<h3 class="semi-bold green">Økonomi</h3>
								</div>
								<div class="flex">
									<div class="col-1 flex justify-center items-center p0 pb3">
										<span class="h3 semi-bold green m0 statusPerc"><span class="perc">0</span>%</span>
									</div>
									<div class="col-11 p0">
										<div class="flex" v-for="(economy, index) in questionData.KlimaSurveyEconomy" :key="index">
											<div class="col-1 flex justify-center p0 mr2">
												<div class="border green-border green-background fullHeight" style="width: 8%;">
												</div>
											</div>
											<div class="col-11 p0 pr2 mb3">
												<p>
													{{economy.headertext}}
												</p>
												<div class="flex">
													<div class="col-12 p0">
														<div v-if="economy.questiontype != 'input-2numbers' && economy.questiontype != 'input-3numbers'">
															<span class="semi-bold">{{economy.title}}</span>
															<div class="mb1"></div>
															<div class="flex">
																<div class="col-11 p0">
																	<el-input-number :id="'input-' + economy.ID" class="col-12 p0 data-id" name="" :placeholder="economy.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')" v-if="economy.questiontype == 'input-number' || economy.questiontype == 'input-float'">
																		<!-- <i slot="suffix" class="h4 bold el-input__icon el-icon-check green" v-if="input1 != ''"></i>
																		<i slot="suffix" class="" v-else></i> -->
																	</el-input-number>
																	<b-form-select :id="'select-' + economy.ID" class="custom-select col-12 data-id" name="" :options="economy.options" @change="calculatePercentageFields(economy.UNgoal, economy.ID, 'select')" v-else-if="economy.questiontype == 'input-list'"></b-form-select>
																</div>
																<div class="col-1 p0">
																	<div class="col-12 flex justify-center items-end p0">
																		<el-tooltip :content="economy.info1" placement="top" v-if="economy.info1 != ''">
																			<i class="h5 el-icon-question mintgreen"></i>
																		</el-tooltip>
																	</div>
																</div>
															</div>
														</div>
														<div v-else-if="economy.questiontype == 'input-2numbers' || economy.questiontype == 'input-3numbers'">
															<div v-if="economy.questiontype == 'input-2numbers'">
																<span class="semi-bold">{{economy.title}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + economy.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="economy.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="economy.info1" placement="top" v-if="economy.info1 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
																<span class="semi-bold">{{economy.title1}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + economy.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="economy.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="economy.info2" placement="top" v-if="economy.info2 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
															</div>
															<div v-else-if="economy.questiontype == 'input-3numbers'">
																<span class="semi-bold">{{economy.title}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + economy.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="economy.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="economy.info1" placement="top" v-if="economy.info1 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
																<span class="semi-bold">{{economy.title1}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + economy.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="economy.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="economy.info2" placement="top" v-if="economy.info2 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
																<span class="semi-bold">{{economy.title2}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + economy.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="economy.placeholder3" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="economy.info3" placement="top" v-if="economy.info3 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- Social -->
							<div id="question2" class="mb4 question" v-if="!noSocial">
								<div class="pb4 px3">
									<h3 class="semi-bold green">Social</h3>
								</div>
								<div class="flex">
									<div class="col-1 flex justify-center items-center p0 pb3">
										<span class="h3 semi-bold green m0 statusPerc"><span class="perc">0</span>%</span>
									</div>
									<div class="col-11 p0">
										<div class="flex" v-for="(social, index) in questionData.KlimaSurveySocial" :key="index">
											<div class="col-1 flex justify-center p0 mr2">
												<div class="border green-border green-background fullHeight" style="width: 8%;">
												</div>
											</div>
											<div class="col-11 p0 pr2 mb3">
												<p>
													{{social.headertext}}
												</p>
												<div class="flex">
													<div class="col-12 p0">
														<div v-if="social.questiontype != 'input-2numbers' && social.questiontype != 'input-3numbers'">
															<span class="semi-bold">{{social.title}}</span>
															<div class="mb1"></div>
															<div class="flex">
																<div class="col-11 p0">
																	<el-input-number :id="'input-' + social.ID" class="col-12 p0 data-id" name="" :placeholder="social.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')" v-if="social.questiontype == 'input-number' || social.questiontype == 'input-float'">
																		<!-- <i slot="suffix" class="h4 bold el-input__icon el-icon-check green" v-if="input1 != ''"></i>
																		<i slot="suffix" class="" v-else></i> -->
																	</el-input-number>
																	<b-form-select :id="'select-' + social.ID" class="custom-select col-12 data-id" name="" :options="social.options" @change="calculatePercentageFields(social.UNgoal, social.ID, 'select')" v-else-if="social.questiontype == 'input-list'"></b-form-select>
																</div>
																<div class="col-1 p0">
																	<div class="col-12 flex justify-center items-end p0">
																		<el-tooltip :content="social.info1" placement="top" v-if="social.info1 != ''">
																			<i class="h5 el-icon-question mintgreen"></i>
																		</el-tooltip>
																	</div>
																</div>
															</div>
														</div>
														<div v-else-if="social.questiontype == 'input-2numbers' || social.questiontype == 'input-3numbers'">
															<div v-if="social.questiontype == 'input-2numbers'">
																<span class="semi-bold">{{social.title}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + social.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="social.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="social.info1" placement="top" v-if="social.info1 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
																<span class="semi-bold">{{social.title1}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + social.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="social.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="social.info2" placement="top" v-if="social.info2 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
															</div>
															<div v-else-if="social.questiontype == 'input-3numbers'">
																<span class="semi-bold">{{social.title}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + social.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="social.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="social.info1" placement="top" v-if="social.info1 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
																<span class="semi-bold">{{social.title1}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + social.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="social.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="social.info2" placement="top" v-if="social.info2 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
																<span class="semi-bold">{{social.title2}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + social.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="social.placeholder3" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="social.info3" placement="top" v-if="social.info3 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- Environment -->
							<div id="question3" class="mb4 question" v-if="!noEnvironment">
								<div class="pb4 px3">
									<h3 class="semi-bold green">Miljø</h3>
								</div>
								<div class="flex">
									<div class="col-1 flex justify-center items-center p0 pb3">
										<span class="h3 semi-bold green m0 statusPerc"><span class="perc">0</span>%</span>
									</div>
									<div class="col-11 p0">
										<div class="flex" v-for="(environment, index) in questionData.KlimaSurveyEnvironment" :key="index">
											<div class="col-1 flex justify-center p0 mr2">
												<div class="border green-border green-background fullHeight" style="width: 8%;">
												</div>
											</div>
											<div class="col-11 p0 pr2 mb3">
												<p>
													{{environment.headertext}}
												</p>
												<div class="flex">
													<div class="col-12 p0">
														<div v-if="environment.questiontype != 'input-2numbers' && environment.questiontype != 'input-3numbers'">
															<span class="semi-bold">{{environment.title}}</span>
															<div class="mb1"></div>
															<div class="flex">
																<div class="col-11 p0">
																	<el-input-number :id="'input-' + environment.ID" class="col-12 p0 data-id" name="" :placeholder="environment.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')" v-if="environment.questiontype == 'input-number' || environment.questiontype == 'input-float'">
																		<!-- <i slot="suffix" class="h4 bold el-input__icon el-icon-check green" v-if="input1 != ''"></i>
																		<i slot="suffix" class="" v-else></i> -->
																	</el-input-number>
																	<b-form-select :id="'select-' + environment.ID" class="custom-select col-12 data-id" name="" :options="environment.options" @change="calculatePercentageFields(environment.UNgoal, environment.ID, 'select')" v-else-if="environment.questiontype == 'input-list'"></b-form-select>
																</div>
																<div class="col-1 p0">
																	<div class="col-12 flex justify-center items-end p0">
																		<el-tooltip :content="environment.info1" placement="top" v-if="environment.info1 != ''">
																			<i class="h5 el-icon-question mintgreen"></i>
																		</el-tooltip>
																	</div>
																</div>
															</div>
														</div>
														<div v-else-if="environment.questiontype == 'input-2numbers' || environment.questiontype == 'input-3numbers'">
															<div v-if="environment.questiontype == 'input-2numbers'">
																<span class="semi-bold">{{environment.title}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + environment.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="environment.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="environment.info1" placement="top" v-if="environment.info1 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
																<span class="semi-bold">{{environment.title1}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + environment.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="environment.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="environment.info2" placement="top" v-if="environment.info2 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
															</div>
															<div v-else-if="environment.questiontype == 'input-3numbers'">
																<span class="semi-bold">{{environment.title}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + environment.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="environment.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="environment.info1" placement="top" v-if="environment.info1 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
																<span class="semi-bold">{{environment.title1}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + environment.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="environment.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="environment.info2" placement="top" v-if="environment.info2 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
																<span class="semi-bold">{{environment.title2}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + environment.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="environment.placeholder3" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')">
																		</el-input-number>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="environment.info3" placement="top" v-if="environment.info3 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="flex mb2">
								<div class="col-1 flex justify-center items-end p0 pb3 invisible">
									<span class="h3 semi-bold green m0"></span>
								</div>
								<div class="col-1 flex justify-center p0 mr2 invisible">
									<div class="border green-border green-background fullHeight" style="width: 8%;">
									</div>
								</div>
								<div class="col-9 p0 pr2">
									<p class="pl2 mediumgrey-text">Sidst gemt: {{lastSaved}}</p>
									<button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" :disabled="disableSubmit" @click="saveQuestion()">
				                      <span>SEND TIL KLIMAHÅNDVÆRKER</span>
				                      <span class="pl1"><i class="bold el-icon-right"></i></span>
				                    </button>
								</div>
							</div>
						</div>
						<div class="col-3 p0">
							<img src="/static/svg/clean-water-and-sanitation-color.svg" class="mb2" width="100%" v-if="indicatorData.ind6.active">
							<img src="/static/svg/clean-water-and-sanitation.svg" class="mb2" width="100%" v-else>
							<img src="/static/svg/affordable-and-clean-energy-color.svg" class="mb2" width="100%" v-if="indicatorData.ind7.active">
							<img src="/static/svg/affordable-and-clean-energy.svg" class="mb2" width="100%" v-else>
							<img src="/static/svg/decent-economic-growth-color.svg" class="mb2" width="100%" v-if="indicatorData.ind8.active">
							<img src="/static/svg/decent-economic-growth.svg" class="mb2" width="100%" v-else>
							<img src="/static/svg/sustainable-cities-and-communities-color.svg" class="mb2" width="100%" v-if="indicatorData.ind11.active">
							<img src="/static/svg/sustainable-cities-and-communities.svg" class="mb2" width="100%" v-else>
							<img src="/static/svg/responsible-consumption-and-production-color.svg" class="mb2" width="100%" v-if="indicatorData.ind12.active">
							<img src="/static/svg/responsible-consumption-and-production.svg" class="mb2" width="100%" v-else>
							<img src="/static/svg/climate-action-color.svg" width="100%" v-if="indicatorData.ind13.active">
							<img src="/static/svg/climate-action.svg" width="100%" v-else>
						</div>
					</div>
				</div>
				<div class="flex" v-else>
					<div class="col-9 p0 pr2">
						<el-tabs v-model="activeTab">
						    <el-tab-pane id="question1" class="question" label="economy" name="1" v-if="!noEconomy">
						    	<!-- Economy -->
								<div class="mb4">
									<div class="pb4 px3">
										<h3 class="semi-bold green">Økonomi</h3>
									</div>
									<div class="flex">
										<div class="col-1 flex justify-center items-center p0 pb3">
											<span class="h3 semi-bold green m0 statusPerc"><span class="perc">0</span>%</span>
										</div>
										<div class="col-11 p0">
											<div class="flex" v-for="(economy, index) in questionData.KlimaSurveyEconomy" :key="index">
												<div class="col-1 flex justify-center p0 mr2">
													<div class="border green-border green-background fullHeight" style="width: 8%;">
													</div>
												</div>
												<div class="col-11 p0 pr2 mb3">
													<p>
														{{economy.headertext}}
													</p>
													<div class="flex">
														<div class="col-12 p0">
															<div v-if="economy.questiontype != 'input-2numbers' && economy.questiontype != 'input-3numbers'">
																<span class="semi-bold">{{economy.title}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + economy.ID" class="col-12 p0 data-id" name="" :placeholder="economy.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')" v-if="economy.questiontype == 'input-number' || economy.questiontype == 'input-float' && economy.partneroption != 'false'">
																			<!-- <i slot="suffix" class="h4 bold el-input__icon el-icon-check green" v-if="input1 != ''"></i>
																			<i slot="suffix" class="" v-else></i> -->
																		</el-input-number>
																		<b-form-select :id="'select-' + economy.ID" class="custom-select col-12 data-id" name="" :options="economy.options" @change="calculatePercentageFields(economy.UNgoal, economy.ID, 'select')" v-else-if="economy.questiontype == 'input-list'"></b-form-select>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="economy.info1" placement="top" v-if="economy.info1 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
															</div>
															<div v-else-if="economy.questiontype == 'input-2numbers' || economy.questiontype == 'input-3numbers'">
																<div v-if="economy.questiontype == 'input-2numbers'">
																	<span class="semi-bold">{{economy.title}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + economy.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="economy.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')" v-if="economy.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="economy.info1" placement="top" v-if="economy.info1 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																	<span class="semi-bold">{{economy.title1}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + economy.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="economy.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')" v-if="economy.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="economy.info2" placement="top" v-if="economy.info2 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																</div>
																<div v-else-if="economy.questiontype == 'input-3numbers'">
																	<span class="semi-bold">{{economy.title}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + economy.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="economy.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')" v-if="economy.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="economy.info1" placement="top" v-if="economy.info1 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																	<span class="semi-bold">{{economy.title1}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + economy.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="economy.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')" v-if="economy.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="economy.info2" placement="top" v-if="economy.info2 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																	<span class="semi-bold">{{economy.title2}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + economy.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="economy.placeholder3" :controls="false" :min="1" @blur="calculatePercentageFields(economy.UNgoal, economy.ID, 'input')" v-if="economy.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="economy.info3" placement="top" v-if="economy.info3 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="flex mb2">
									<div class="col-1 flex justify-center items-end p0 pb3 invisible">
										<span class="h3 semi-bold green m0"></span>
									</div>
									<div class="col-1 flex justify-center p0 mr2 invisible">
										<div class="border green-border green-background fullHeight" style="width: 8%;">
										</div>
									</div>
									<div class="col-9 p0 pr2">
					                    <button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" @click="approve('economy', 1)" v-if="!noSocial">
					                      <span>GODKEND ØKONOMI</span>
									   	  <span class="pl1"><i class="bold el-icon-right"></i></span>
					                    </button>
					                    <button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" @click="approve('economy', 2)" v-else-if="!noEnvironment">
					                      <span>GODKEND ØKONOMI</span>
										  <span class="pl1"><i class="bold el-icon-right"></i></span>
					                    </button>
										<button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" @click="saveQuestion()" v-else>
					                      <span>GODKEND ØKONOMI</span>
					                      <span class="pl1"><i class="bold el-icon-right"></i></span>
					                    </button>
									</div>
								</div>
						    </el-tab-pane>
						    <el-tab-pane id="question2" class="question" label="social" name="2" v-if="!noSocial">
						    	<!-- Social -->
								<div class="mb4">
									<div class="pb4 px3">
										<h3 class="semi-bold green">Social</h3>
									</div>
									<div class="flex">
										<div class="col-1 flex justify-center items-center p0 pb3">
											<span class="h3 semi-bold green m0 statusPerc"><span class="perc">0</span>%</span>
										</div>
										<div class="col-11 p0">
											<div class="flex" v-for="(social, index) in questionData.KlimaSurveySocial" :key="index">
												<div class="col-1 flex justify-center p0 mr2">
													<div class="border green-border green-background fullHeight" style="width: 8%;">
													</div>
												</div>
												<div class="col-11 p0 pr2 mb3">
													<p>
														{{social.headertext}}
													</p>
													<div class="flex">
														<div class="col-12 p0">
															<div v-if="social.questiontype != 'input-2numbers' && social.questiontype != 'input-3numbers'">
																<span class="semi-bold">{{social.title}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + social.ID" class="col-12 p0 data-id" name="" :placeholder="social.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')" v-if="social.questiontype == 'input-number' || social.questiontype == 'input-float' && social.partneroption != 'false'">
																			<!-- <i slot="suffix" class="h4 bold el-input__icon el-icon-check green" v-if="input1 != ''"></i>
																			<i slot="suffix" class="" v-else></i> -->
																		</el-input-number>
																		<b-form-select :id="'select-' + social.ID" class="custom-select col-12 data-id" name="" :options="social.options" @change="calculatePercentageFields(social.UNgoal, social.ID, 'select')" v-else-if="social.questiontype == 'input-list'"></b-form-select>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="social.info1" placement="top" v-if="social.info1 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
															</div>
															<div v-else-if="social.questiontype == 'input-2numbers' || social.questiontype == 'input-3numbers'">
																<div v-if="social.questiontype == 'input-2numbers'">
																	<span class="semi-bold">{{social.title}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + social.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="social.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')" v-if="social.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="social.info1" placement="top" v-if="social.info1 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																	<span class="semi-bold">{{social.title1}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + social.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="social.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')" v-if="social.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="social.info2" placement="top" v-if="social.info2 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																</div>
																<div v-else-if="social.questiontype == 'input-3numbers'">
																	<span class="semi-bold">{{social.title}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + social.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="social.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')" v-if="social.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="social.info1" placement="top" v-if="social.info1 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																	<span class="semi-bold">{{social.title1}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + social.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="social.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')" v-if="social.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="social.info2" placement="top" v-if="social.info2 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																	<span class="semi-bold">{{social.title2}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + social.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="social.placeholder3" :controls="false" :min="1" @blur="calculatePercentageFields(social.UNgoal, social.ID, 'input')" v-if="social.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="social.info3" placement="top" v-if="social.info3 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="flex mb2">
									<div class="col-1 flex justify-center items-end p0 pb3 invisible">
										<span class="h3 semi-bold green m0"></span>
									</div>
									<div class="col-1 flex justify-center p0 mr2 invisible">
										<div class="border green-border green-background fullHeight" style="width: 8%;">
										</div>
									</div>
									<div class="col-9 p0 pr2 flex flex-wrap">
										<button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" @click="approve('social', 0)" v-if="!noEconomy">
										  <span class="pr1"><i class="bold el-icon-back"></i></span>
					                      <span>TILBAGE</span>
					                    </button>
										<button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" @click="approve('social', 2)" v-if="!noEnvironment">
					                      <span>GODKEND SOCIAL</span>
					                      <span class="pl1"><i class="bold el-icon-right"></i></span>
					                    </button>
					                    <button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" @click="saveQuestion()" v-else>
					                      <span>GODKEND SOCIAL</span>
					                      <span class="pl1"><i class="bold el-icon-right"></i></span>
					                    </button>
									</div>
								</div>
						    </el-tab-pane>
						    <el-tab-pane id="question3" class="question" label="miljø" name="3" v-if="!noEnvironment">
						    	<!-- Environment -->
								<div class="mb4">
									<div class="pb4 px3">
										<h3 class="semi-bold green">Miljø</h3>
									</div>
									<div class="flex">
										<div class="col-1 flex justify-center items-center p0 pb3">
											<span class="h3 semi-bold green m0 statusPerc"><span class="perc">0</span>%</span>
										</div>
										<div class="col-11 p0">
											<div class="flex" v-for="(environment, index) in questionData.KlimaSurveyEnvironment" :key="index">
												<div class="col-1 flex justify-center p0 mr2">
													<div class="border green-border green-background fullHeight" style="width: 8%;">
													</div>
												</div>
												<div class="col-11 p0 pr2 mb3">
													<p>
														{{environment.headertext}}
													</p>
													<div class="flex">
														<div class="col-12 p0">
															<div v-if="environment.questiontype != 'input-2numbers' && environment.questiontype != 'input-3numbers'">
																<span class="semi-bold">{{environment.title}}</span>
																<div class="mb1"></div>
																<div class="flex">
																	<div class="col-11 p0">
																		<el-input-number :id="'input-' + environment.ID" class="col-12 p0 data-id" name="" :placeholder="environment.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')" v-if="environment.questiontype == 'input-number' || environment.questiontype == 'input-float' && environment.partneroption != 'false'">
																			<!-- <i slot="suffix" class="h4 bold el-input__icon el-icon-check green" v-if="input1 != ''"></i>
																			<i slot="suffix" class="" v-else></i> -->
																		</el-input-number>
																		<b-form-select :id="'select-' + environment.ID" class="custom-select col-12 data-id" name="" placeholder="kg" :options="environment.options" @change="calculatePercentageFields(environment.UNgoal, environment.ID, 'select')" v-else-if="environment.questiontype == 'input-list'"></b-form-select>
																	</div>
																	<div class="col-1 p0">
																		<div class="col-12 flex justify-center items-end p0">
																			<el-tooltip :content="environment.info1" placement="top" v-if="environment.info1 != ''">
																				<i class="h5 el-icon-question mintgreen"></i>
																			</el-tooltip>
																		</div>
																	</div>
																</div>
															</div>
															<div v-else-if="environment.questiontype == 'input-2numbers' || environment.questiontype == 'input-3numbers'">
																<div v-if="environment.questiontype == 'input-2numbers'">
																	<span class="semi-bold">{{environment.title}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + environment.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="environment.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')" v-if="environment.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="environment.info1" placement="top" v-if="environment.info1 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																	<span class="semi-bold">{{environment.title1}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + environment.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="environment.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')" v-if="environment.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="environment.info2" placement="top" v-if="environment.info2 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																</div>
																<div v-else-if="environment.questiontype == 'input-3numbers'">
																	<span class="semi-bold">{{environment.title}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + environment.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="environment.placeholder1" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')" v-if="environment.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="environment.info1" placement="top" v-if="environment.info1 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																	<span class="semi-bold">{{environment.title1}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + environment.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="environment.placeholder2" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')" v-if="environment.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="environment.info2" placement="top" v-if="environment.info2 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																	<span class="semi-bold">{{environment.title2}}</span>
																	<div class="mb1"></div>
																	<div class="flex">
																		<div class="col-11 p0">
																			<el-input-number :id="'input-' + environment.ID" class="col-12 p0 mb3 data-id" name="" :placeholder="environment.placeholder3" :controls="false" :min="1" @blur="calculatePercentageFields(environment.UNgoal, environment.ID, 'input')" v-if="environment.partneroption != 'false'">
																			</el-input-number>
																		</div>
																		<div class="col-1 p0">
																			<div class="col-12 flex justify-center items-end p0">
																				<el-tooltip :content="environment.info3" placement="top" v-if="environment.info3 != ''">
																					<i class="h5 el-icon-question mintgreen"></i>
																				</el-tooltip>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="flex mb2">
									<div class="col-1 flex justify-center items-end p0 pb3 invisible">
										<span class="h3 semi-bold green m0"></span>
									</div>
									<div class="col-1 flex justify-center p0 mr2 invisible">
										<div class="border green-border green-background fullHeight" style="width: 8%;">
										</div>
									</div>
									<div class="col-9 p0 pr2 flex flex-wrap">
										<button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" @click="approve('environment', 1)" v-if="!noSocial">
										  <span class="pr1"><i class="bold el-icon-back"></i></span>
					                      <span>TILBAGE</span>
					                    </button>
					                    <button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" @click="approve('environment', 0)" v-else>
										  <span class="pr1"><i class="bold el-icon-back"></i></span>
					                      <span>TILBAGE</span>
					                    </button>
										<button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" @click="saveQuestion()">
					                      <span>GODKEND MILJØ</span>
					                      <span class="pl1"><i class="bold el-icon-right"></i></span>
					                    </button>
									</div>
								</div>
							</el-tab-pane>
					  	</el-tabs>
					</div>
				  	<div class="col-3 p0">
						<img src="/static/svg/clean-water-and-sanitation-color.svg" class="mb2" width="100%" v-if="indicatorData.ind6.active">
						<img src="/static/svg/clean-water-and-sanitation.svg" class="mb2" width="100%" v-else>
						<img src="/static/svg/affordable-and-clean-energy-color.svg" class="mb2" width="100%" v-if="indicatorData.ind7.active">
						<img src="/static/svg/affordable-and-clean-energy.svg" class="mb2" width="100%" v-else>
						<img src="/static/svg/decent-economic-growth-color.svg" class="mb2" width="100%" v-if="indicatorData.ind8.active">
						<img src="/static/svg/decent-economic-growth.svg" class="mb2" width="100%" v-else>
						<img src="/static/svg/sustainable-cities-color.svg" class="mb2" width="100%" v-if="indicatorData.ind11.active">
							<img src="/static/svg/sustainable-cities.svg" class="mb2" width="100%" v-else>
						<img src="/static/svg/responsible-consumption-and-production-color.svg" class="mb2" width="100%" v-if="indicatorData.ind12.active">
						<img src="/static/svg/responsible-consumption-and-production.svg" class="mb2" width="100%" v-else>
						<img src="/static/svg/climate-action-color.svg" width="100%" v-if="indicatorData.ind13.active">
						<img src="/static/svg/climate-action.svg" width="100%" v-else>
					</div>
				</div>
				<simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
  import Simplert from 'vue2-simplert'
  export default {
    name: '',
    components: {
      Simplert
    },
    data () {
      return {
        questionLoading: true,
        id: '',
        isCustomer: false,
        activeTab: '1',
        questionData: [],
        value: '',
        selected: '',
        indicatorData: {
          ind6: {
            active: false
          },
          ind7: {
            active: false
          },
          ind8: {
            active: false
          },
          ind11: {
            active: false
          },
          ind12: {
            active: false
          },
          ind13: {
            active: false
          }
        },
        disableSubmit: false,
        lastSaved: '',
        noEconomy: '',
        noSocial: '',
        noEnvironment: ''
      }
    },
    created () {
      /* eslint-disable no-mixed-spaces-and-tabs */
      /* eslint-disable no-tabs */
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var urlStr = window.location.href
      var url = new URL(urlStr.replace('/#', ''))
      var searchParams = url.searchParams
      var id = searchParams.get('id')
	  this.id = id
      var mode = searchParams.get('mode')
      if (mode === 'customer') {
        this.isCustomer = true
      } else {
        this.isCustomer = false
      }
      this.displayQuestion()
    },
    methods: {
      approve (value, tab) {
        tab = tab + 1
        this.activeTab = tab.toString()
      },
      displayQuestion () {
      	/* eslint-disable no-unused-vars */
      	var data = JSON.stringify({
		  operation: 'klimaapi',
		  bitrixoperation: 'getKlimaQuestion',
		  id: this.id
        })
      	this.$http.post('https://www.kundematch.dk/customerService.php', data, { emulateJSON: true }).then(
	    	response => {
	          var res = response.body
	          if (res.success) {
	          	this.questionData = res.data
	          	var economyCount = 0
	          	for (var economy in res.data.KlimaSurveyEconomy) {
	          		economyCount++
	          	}
	          	if (economyCount > 0) {
		          	this.noEconomy = false
	          	} else {
	          		this.noEconomy = true
	          	}
	          	var socialCount = 0
	          	for (var social in res.data.KlimaSurveySocial) {
	          		socialCount++
	          	}
	          	if (socialCount > 0) {
		          	this.noSocial = false
	          	} else {
	          		this.noSocial = true
	          	}
	          	var environmentCount = 0
	          	for (var environment in res.data.KlimaSurveyEnvironment) {
	          		environmentCount++
	          	}
	          	if (environmentCount > 0) {
		          	this.noEnvironment = false
	          	} else {
	          		this.noEnvironment = true
	          	}
	          	if (this.isCustomer) {
	          		this.lastSaved = res.data.latestupdate.customer_answer_date
	          	} else {
	          		this.lastSaved = res.data.latestupdate.partner_answer_date
	          	}
	          	this.questionLoading = false
	          } else {
	            this.$toastr('error', 'Fjernet')
	          }
	        },
	        response => {
	          alert('Error in displayQuestion()')
	        }
      	)
      },
      calculatePercentageFields (UNGoal, surveyId, type) {
      	if (type === 'input') {
      		var inputVal = document.querySelector('.question #input-' + surveyId + ' input').value
	      	if (inputVal !== '') {
	      		this.indicatorData['ind' + UNGoal].active = true
	      	} else {
	      		this.indicatorData['ind' + UNGoal].active = false
	      	}
      	} else if (type === 'select') {
      		var selectVal = document.querySelector('.question #select-' + surveyId).value
	      	if (selectVal !== '') {
	      		this.indicatorData['ind' + UNGoal].active = true
	      	} else {
	      		this.indicatorData['ind' + UNGoal].active = false
	      	}
      	}
      	var qstn = document.querySelectorAll('.question')
      	for (var i = 0; i < qstn.length; i++) {
      		var totalFields = 0
	      	var percValue = 0
	      	var totalPercValue = 0
      		var input = document.querySelectorAll('#' + qstn[i].id + ' input')
      		var select = document.querySelectorAll('#' + qstn[i].id + ' select')
      		var oldVal = ''
      		for (var x = 0; x < input.length; x++) {
      		}
      		for (var j = 0; j < select.length; j++) {
      		}
      		totalFields = x + j
      		percValue = 100 / totalFields
      		for (var k = 0; k < input.length; k++) {
      			if (input[k].value !== '') {
      				totalPercValue += percValue
      			} else {
      				if (input[k].value !== oldVal) {
      					if (totalPercValue > 0) {
	      					totalPercValue -= percValue
	      				}
	      				oldVal = input[k].value
      				}
      			}
      		}
      		for (var l = 0; l < select.length; l++) {
      			if (select[l].value !== '') {
      				totalPercValue += percValue
      			}
      		}
      		if (Number.isInteger(totalPercValue)) {
      			document.querySelector('#' + qstn[i].id + ' .perc').innerText = totalPercValue
      		} else {
      			document.querySelector('#' + qstn[i].id + ' .perc').innerText = totalPercValue.toFixed(0)
      		}
      	}
      },
      saveQuestion () {
      	var qstn = document.querySelectorAll('.question')
      	var totalPerc = 0
      	var requiredPerc = 100 * qstn.length
      	for (var v = 0; v < qstn.length; v++) {
      		var perc = document.querySelector('#' + qstn[v].id + ' span.perc').innerText
      		totalPerc += parseInt(perc)
      	}
      	if (totalPerc === requiredPerc) {
	      	var field = document.querySelectorAll('.data-id')
	      	var formData = {}
	      	var count = 0
	      	var qstnId = ''
	      	var prop = ''
	      	var fieldId = ''
	      	var fieldType = ''
	      	var fieldVal = ''
	      	var input = ''
	      	var stopLooped = ''
	      	for (var i = 0; i < field.length; i++) {
	      		var arr = field[i].id.split('-')
	      		fieldType = arr[0]
	      		fieldId = arr[1]
	      		if (qstnId === fieldId) {
	      			count++
	      		} else {
	      			count = 1
	      		}
	      		if (this.isCustomer) {
	      			prop = 'svalue' + count + '_' + fieldId
	      		} else {
	      			prop = 'pvalue' + count + '_' + fieldId
	      		}
	      		if (qstnId === fieldId && qstnId !== stopLooped) {
		      		if (fieldType === 'input') {
		      			input = document.querySelectorAll('#' + field[i].id + ' input')
		      			for (var j = 0; j < input.length; j++) {
		      				if (j !== 0 && j !== count) {
			      				fieldVal = input[j].value
		      					formData[prop] = fieldVal
		      					if (count === input.length) {
					      			stopLooped = fieldId
			      				}
		      				}
		      			}
		      		} else if (fieldType === 'select') {
		      			input = document.querySelectorAll('select#' + field[i].id)
		      			for (var x = 0; x < input.length; x++) {
		      				if (x !== 0 && x !== count) {
			      				fieldVal = input[x].value
		      					formData[prop] = fieldVal
		      					if (count === input.length) {
					      			stopLooped = fieldId
			      				}
		      				}
		      			}
		      		}
		      	} else {
		      		if (fieldType === 'input') {
			      		fieldVal = document.querySelector('#' + field[i].id + ' input').value
		      		} else if (fieldType === 'select') {
		      			fieldVal = document.querySelector('select#' + field[i].id).value
		      		}
		      		formData[prop] = fieldVal
		      	}
	      		qstnId = fieldId
	      	}
	      	var data = JSON.stringify({
			  operation: 'klimaapi',
			  bitrixoperation: 'saveKlimaQuestion',
			  id: this.id,
			  formData
	        })
	      	this.$http.post('https://www.kundematch.dk/customerService.php', data, { emulateJSON: true }).then(
		    	response => {
		          var res = response.body
		          if (res.success) {
		          	this.displayQuestion()
		          	this.$router.push('/questionnaire-thankyou')
		          	this.indicatorData.ind6.active = false
		          	this.indicatorData.ind7.active = false
		          	this.indicatorData.ind8.active = false
		          	this.indicatorData.ind11.active = false
		          	this.indicatorData.ind12.active = false
		          	this.indicatorData.ind13.active = false
		          	this.activeTab = '1'
		          } else {
		            this.$toastr('error', 'Error in saveQuestion()')
		          }
		        },
		        response => {
		          this.$toastr('error', 'Error in saveQuestion()')
		        }
	      	)
	      	this.questionLoading = true
	    } else {
	    	this.$toastr('error', 'Felter påkrævet')
	    }
      }
    },
    watch: {
    }
}
</script>
<style>
	#questionnaire .el-tabs__header {
		display: none;
	}
	#questionnaire .el-input__inner, #questionnaire .custom-select {
		text-align: left;
	}
	#questionnaire .el-tabs__content {
		overflow: unset;
	}
	#questionnaire .el-input-number {
		width: 100% !important;
	}
	.loader,
	.loader:before,
	.loader:after {
		border-radius: 50%;
	}
	.loader {
		color: #143130;
		font-size: 11px;
		text-indent: -99999em;
		margin: 55px auto;
		position: relative;
		width: 10em;
		height: 10em;
		box-shadow: inset 0 0 0 1em;
		-webkit-transform: translateZ(0);
		-ms-transform: translateZ(0);
		transform: translateZ(0);
	}
	.loader:before,
	.loader:after {
		position: absolute;
		content: '';
	}
	.loader:before {
		width: 5.2em;
		height: 10.2em;
		background: white;
		border-radius: 10.2em 0 0 10.2em;
		top: -0.1em;
		left: -0.1em;
		-webkit-transform-origin: 5.2em 5.1em;
		transform-origin: 5.2em 5.1em;
		-webkit-animation: load2 2s infinite ease 1.5s;
		animation: load2 2s infinite ease 1.5s;
	}
	.loader:after {
		width: 5.2em;
		height: 10.2em;
		background: white;
		border-radius: 0 10.2em 10.2em 0;
		top: -0.1em;
		left: 5.1em;
		-webkit-transform-origin: 0px 5.1em;
		transform-origin: 0px 5.1em;
		-webkit-animation: load2 2s infinite ease;
		animation: load2 2s infinite ease;
	}
	@-webkit-keyframes load2 {
		0% {
		  -webkit-transform: rotate(0deg);
		  transform: rotate(0deg);
		}
		100% {
		  -webkit-transform: rotate(360deg);
		  transform: rotate(360deg);
		}
		}
		@keyframes load2 {
		0% {
		  -webkit-transform: rotate(0deg);
		  transform: rotate(0deg);
		}
		100% {
		  -webkit-transform: rotate(360deg);
		  transform: rotate(360deg);
		}
	}
	@media (max-width: 40em) {
	    #questionnaire .statusPerc {
      		font-size: 1rem;
	    }
  	}
</style>


// WEBPACK FOOTER //
// Questionnaire.vue?d825c57e